export const sounds = {
  'SOUND:MULTIPLIER:0': [
    {
      play: 'x1_mult',
      volume: 1,
    },
  ],

  'REELS-RESTART': [
    {
      play: 'respin',
      loop: true,
      volume: .9,
    },
  ],

  'SOUND:MULTIPLIER:3': [
    {
      play: 'x3_mult',
      volume: 1,
    },
  ],
  'SOUND:MULTIPLIER:5': [
    {
      play: 'x5_mult',
      volume: 1,
    },
  ],
  'SOUND:MULTIPLIER:7': [
    {
      play: 'x7_mult',
      volume: 1,
    },
  ],
  'SOUND:MULTIPLIER:9': [
    {
      play: 'x9_mult',
      volume: 1,
    },
  ],

  'COIN:IN': [

    {
      play: 'coins_koala',
      volume: 0.5,
      fade: .6,
      loop: true,
    },
  ],
  'COIN:OUT': [
    {
      stop: 'coins_koala',
      fade: 0.2,
      volume: 0,
    },
  ],

  'SOUND:TOTAL:IN': [
    {
      play: 'counter_total',
      volume: 1,
      loop: true,
    },
  ],
  'SOUND:TOTAL:OUT': [{ stop: 'counter_total' }],

  'SOUND:load|regular': [
    {
      play: 'main_ambient',
      loop: true,
      volume: .8,
      fade: 1,
    },
    {
      play: 'main_music',
      loop: true,
      volume: .4,
      fade: 1,
    },
  ],

  'RADIO:ui': [
    {
      play: 'inside_buttons',
      volume: 1,
    },
  ],

  'BUTTON:BuyOpen': [
    {
      play: 'inside_buttons',
      volume: 2,
    },
  ],

  'BUTTON:BuyClose': [
    {
      play: 'inside_buttons',
      volume: 2,
    },
  ],

  'BUTTON:BuyButton': [
    {
      play: 'buy_button',
      volume: 2,
    },
  ],

  'STATE:IN:FS-ADD': [
    {
      play: 'shooting_free_spin_popup',
      volume: 1,
    },
  ],
  'STATE:IN:FS-START': [
    {
      play: 'lamp_cracking',
      volume: 1,
      loop: true,
      fade: .2,
    },
  ],
  'ACTION:FS-END': [
    {
      play: 'end_free_spin',
      volume: .7,
    },
  ],
  'SOUND:load|freespins': [
    {
      play: 'free_spin_music',
      volume: .4,
      fade: .6,
      loop: true,
    },
    {
      play: 'free_spin_ambient',
      volume: .7,
      fade: .8,
      loop: true,
    },
  ],
  'BUTTON:close': [
    {
      play: 'tap_to_play',
      volume: .3,
    },
  ],
  'RADIO:loss': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'RADIO:win': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'TOGGLE:turbo': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'TOGGLE:left': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BET:bet': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BUTTON:PrevAutoPage': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BUTTON:NextAutoPage': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'SOUND:carousel': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BUTTON:startFreespin': [
    { stop: 'main_ambient' },
    { stop: 'main_music' },
    { stop: 'free_spin_ambient' },
    { stop: 'free_spin_music' },
    {
      play: 'free_spin_music',
      volume: .4,
      fade: .6,
      loop: true,
    },
    {
      play: 'free_spin_ambient',
      volume: .7,
      fade: .8,
      loop: true,
    },
    {
      play: 'free_spin_start',
      volume: .3,
    },
    {
      play: 'platform_appear',
      volume: .6,
    },
  ],
  'STATE:OUT:FS-END': [
    { stop: 'free_spin_ambient' },
    { stop: 'free_spin_music' },
    {
      play: 'main_ambient',
      loop: true,
      volume: .8,
      fade: 1,
    },
    {
      play: 'main_music',
      loop: true,
      volume: .4,
      fade: 1,
    },
  ],
  'BUTTON:prevbet': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BUTTON:nextbet': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BUTTON:maxbet': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BUTTON:prevauto': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BUTTON:nextauto': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BUTTON:maxauto': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'RADIO:menu|paytable': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'RADIO:menu|gamerules': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'RADIO:menu|history': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'RADIO:menu|settings': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'SOUND:ui': [
    {
      play: 'outside_buttons',
      volume: .4,
    },
  ],
  'SOUND:spin-btn:turbo': [
    {
      play: 'button_spin',
      volume: .7,
    },
  ],
  'TOGGLE:intro|true': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'TOGGLE:intro|false': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'TOGGLE:space|true': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'TOGGLE:space|false': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'SOUND:reels-spin:turbo': [
    {
      play: 'reel_spin',
      loop: true,
      fade: .2,
      volume: .3,
    },
  ],
  'SOUND:REEL-STOP': [
    {
      play: 'reel_stop_{n}',
      random: [1, 5],
      volume: 1,
    },

  ],
  'SOUND:SCATTER-BEGIN|2': [
    {
      play: 'scatter_chance',
      volume: .4,
      fade: .2,
    },
  ],
  'SOUND:SCATTER-BEGIN|3': [
    {
      play: 'scatter_chance',
      volume: .7,
      fade: .2,
    },
  ],
  'SOUND:SCATTER-BEGIN|4': [
    {
      play: 'scatter_chance',
      volume: 1,
      fade: .2,
    },
  ],
  'SCATTER:STOP|2': [{ stop: 'scatter_chance' }],
  'SCATTER:STOP|3': [{ stop: 'scatter_chance' }],
  'SCATTER:STOP|4': [{ stop: 'scatter_chance' }],
  'REELS-STOP': [
    { stop: 'reel_spin' },
    { stop: 'respin' },
  ],

  'STATE:OUT:FS-START': [{ stop: 'lamp_cracking' }],
  'SOUND:win:regular': [
    {
      play: 'regular_win',
      volume: .7,
    },
  ],
  'SOUND:win:big': [
    {
      play: 'big_win',
      volume: .5,
    },
  ],
  'SOUND:win:mega': [
    {
      play: 'mega_win',
      volume: .5,
    },
  ],
  'SOUND:win:ultra': [
    {
      play: 'ultra_win',
      volume: .5,
    },
  ],
  'SOUND:SYMBOL-STOP|1': [
    {
      play: 'scatter_stop',
      volume: .6,
    },
  ],
  'BOOK-START': [
    {
      play: 'book_animation',
      volume: .6,
    },
  ],
  'BOOK-END': [
    {
      play: 'book_win_animation',
      volume: .6,
    },
    {
      play: 'final_drop_book_symbol',
      volume: .6,
    },
  ],

  'TRANSITION-BONUS-ANIM': [
    {
      play: 'transition_past_time',
      volume: 1,
    },
  ],

  'CHOISE-POPUP-ANIM-PLAY': [
    {
      play: 'select_bonus_game_koala',
      volume: 1,
    },
  ],

  'SHOW:SYMBOL': [
    {
      play: 'drop_book_symbols',
      volume: .6,
    },
  ],
  'SPREAD-SYMBOL': [
    {
      play: 'expanding_special_symbol',
      volume: .6,
    },
  ],
  'STATE:IN:FB-ADD': [
    {
      play: 'free_bet_big_win',
      volume: .7,
    },
  ],
  'FREEBET:TOTAL-WIN:big': [
    {
      play: 'free_bet_big_win',
      volume: .7,
    },
  ],
  'FREEBET:TOTAL-WIN:ultra': [
    {
      play: 'free_bet_ultra_win',
      volume: .7,
    },
  ],
  'FREEBET:TOTAL-WIN:mega': [
    {
      play: 'free_bet_mega_win',
      volume: .7,
    },
  ],
  'FREEBET:TOTAL-WIN:total': [
    {
      play: 'free_bet_total_win',
      volume: .7,
    },
  ],
}

export const delays = {
  regular: .5,
  turbo: .3,
}
export const wins = []
